<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [hideHeader]="true"
  [showFooter]="false"
  placement="center"
  [panelWidth]="panelWidth()"
  panelClass="eventq-media-enlarge-popover__panel"
  (closed)="onClose()"
>
  <div class="eventq-media-enlarge-popover" data-testid="media-enlarge-popover">
    <header class="eventq-media-enlarge-popover__header">
      <h2 class="eventq-media-enlarge-popover__title">{{ title() }}</h2>
      <div class="eventq-media-enlarge-popover__actions">
        @if (deletable()) {
          <button
            type="button"
            class="eventq-media-enlarge-popover__delete"
            aria-label="Delete"
            data-testid="media-enlarge-delete"
            (click)="onDelete($event)"
          >
            <mat-icon aria-hidden="true">delete</mat-icon>
          </button>
        }
        <button
          type="button"
          class="eventq-media-enlarge-popover__close"
          aria-label="Close"
          data-testid="media-enlarge-close"
          (click)="onClose()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
    </header>

    <div class="eventq-media-enlarge-popover__body">
      @if (variant() === 'snapshot') {
        <img
          class="eventq-media-enlarge-popover__image"
          [src]="imageSrc() ?? ''"
          [alt]="title()"
          data-testid="media-enlarge-image"
        />
      } @else {
        <div class="eventq-media-enlarge-popover__clip">
          <div class="eventq-media-enlarge-popover__footage">
            <video
              #videoEl
              class="eventq-media-enlarge-popover__video"
              [src]="videoSrc() ?? null"
              [poster]="posterSrc() ?? null"
              playsinline
              data-testid="media-enlarge-video"
              (timeupdate)="onTimeUpdate()"
              (loadedmetadata)="onLoadedMetadata()"
              (ended)="onVideoEnded()"
            ></video>
          </div>
          <eventq-mini-playback-controls
            [elapsedLabel]="elapsedLabel()"
            [durationLabel]="durationLabel()"
            [progress]="progress()"
            [playing]="playing()"
            [disabled]="playbackDisabled()"
            (playToggle)="onPlayToggle()"
            (seek)="onSeek($event)"
          />
        </div>
      }
    </div>
  </div>
</eventq-dialog-popover>
